import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import Tooltip from '../../../components/Tooltip';
import './ProjectCardCarbon.scss';

import {
  CARBON_ACTIVE, CARBON_REJECTED,
  CARBON_SUBMITTED, CARBON_NOT_FINALISED,
  CARBON_NOT_STARTED,
} from '../../../constans/constans';

import { ReactComponent as CarbonActiveIcon } from '../../../assets/image/existing-projects/carbon-active.svg';
import { ReactComponent as CarbonNotFinalisedIcon } from '../../../assets/image/existing-projects/carbon-not-finalised.svg';
import { ReactComponent as CarbonSubmittedIcon } from '../../../assets/image/existing-projects/carbon-submitted.svg';

const ProjectCardCarbon = ({ carbonApplication, leakage, projectId }) => {
  const translate = useIntl();
  const [tooltipData] = useState({
    [CARBON_ACTIVE]: {
      icon: <CarbonActiveIcon data-tip data-for={`${projectId}-carbon`} />,
      text: translate.formatMessage({ id: 'projectCard.toolTip.carbon.active' }),
      uniqueProps: { textColor: '#329D9C', borderColor: '#329D9C', offset: { right: 47 } },
    },
    [CARBON_SUBMITTED]: {
      icon: <CarbonSubmittedIcon data-tip data-for={`${projectId}-carbon`} />,
      text: translate.formatMessage({ id: 'projectCard.toolTip.carbon.submitted' }),
      uniqueProps: { textColor: '#3E80FF', borderColor: '#3E80FF', offset: { right: 73 } },
    },
    [CARBON_NOT_FINALISED]: {
      icon: <CarbonNotFinalisedIcon data-tip data-for={`${projectId}-carbon`} />,
      text: translate.formatMessage({ id: 'projectCard.toolTip.carbon.notFinalised' }),
      uniqueProps: { textColor: '#FABC73', borderColor: '#FABC73', offset: { right: 78 } },
    },
  });

  const getCarbonStatus = () => {
    // Leakage data exists if carbon application was approved or rejected
    if (leakage) return leakage.carbonApprove ? CARBON_ACTIVE : CARBON_REJECTED;

    // Carbon application data exists if user save data in carbon form
    if (carbonApplication) return carbonApplication.completed ? CARBON_SUBMITTED : CARBON_NOT_FINALISED;

    // If carbon application has not been started
    return CARBON_NOT_STARTED;
  };

  const carbonStatus = getCarbonStatus();
  const activeTooltip = tooltipData[carbonStatus];

  return activeTooltip ? (
    <div className="card-carbon">
      <Tooltip
        targetClass="icon-wrapper"
        targetElement={activeTooltip.icon}
        tooltipElement={activeTooltip.text}
        tooltipProps={{
          className: 'status-tooltip',
          place: 'top',
          type: 'light',
          id: `${projectId}-carbon`,
          effect: 'solid',
          border: true,
          ...activeTooltip.uniqueProps,
        }}
      />
    </div>
  ) : null;
};

export default ProjectCardCarbon;
